import { styled, TextField } from "@mui/material";

const InputFilterFieldStyled = styled(TextField)({
    "& label.Mui-focused": {
        color: "#586A84",
        fontSize: 16,
    },
    "& label": {
        color: "#586A84",
        fontSize: 14,
        paddingTop: 1,
    },
    "& label.MuiFormLabel-filled.MuiInputLabel-shrink": {
        color: "#586A84",
        fontSize: 16,
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: "#405289",
        borderRadius: "6px",
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "#BEC3C9",
            borderRadius: "6px",
        },
        "&:hover fieldset": {
            borderColor: "#405289",
            borderRadius: "6px",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#405289",
            borderRadius: "6px",
        },
    },
});

export default InputFilterFieldStyled;
